import { FC, useEffect, SyntheticEvent, Dispatch, SetStateAction } from "react";
import { Collection } from "src/organisms/AddToCollection/AddToCollection";
import { StyledDropdown } from "./CollectionSelect.styled";
interface Props {
  collections: Collection[];
  selectedCollection: string;
  setSelectedCollection: Dispatch<SetStateAction<string>>;
}

const CollectionSelect: FC<Props> = ({
  collections,
  selectedCollection,
  setSelectedCollection,
}) => {
  useEffect(() => {
    const selectedCollectionFromLocalStorage =
      localStorage.getItem("selectedCollection");
    if (selectedCollectionFromLocalStorage) {
      setSelectedCollection(selectedCollectionFromLocalStorage);
    }
  }, [setSelectedCollection]);

  const onCollectionChange = (
    _event: SyntheticEvent<HTMLElement>,
    { value }: { value: string }
  ) => {
    window.localStorage.setItem("selectedCollection", value);
    setSelectedCollection(value);
    return true;
  };

  return (
    <StyledDropdown
      fluid
      search
      selection
      options={collections.map((collection) => {
        return {
          key: collection.id,
          text: collection.name,
          value: collection.id,
        };
      })}
      // @ts-expect-error Fix types
      onChange={onCollectionChange}
      placeholder="Please choose a collection"
      value={selectedCollection}
    />
  );
};

export default CollectionSelect;
